import { useEffect } from 'react'
import {
  Routes,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router-dom'

import * as Sentry from '@sentry/react'

const isProd = import.meta.env.PROD

/**
 * Sentry を初期化する。`VITE_SENTRY_DSN` が未設定の場合は何もしない
 * （ローカル開発ではノイズを送らない）。main.tsx の描画前に一度だけ呼ぶ。
 */
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    integrations: [
      // React Router（v6+）の宣言的ルーティング向けトレース連携。
      // ページ遷移をトランザクションとして計測する。
      Sentry.reactRouterBrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      }),
      // エラー発生時のみセッションリプレイを記録する。
      Sentry.replayIntegration()
    ],
    // パフォーマンストレースのサンプリング率（本番は絞る）。
    tracesSampleRate: isProd ? 0.1 : 1.0,
    // 通常セッションのリプレイは記録せず、エラー時のみ記録してコストを抑える。
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0
  })
}

/**
 * `<Routes>` を Sentry のルーティング計測でラップしたコンポーネント。
 * App.tsx では素の `<Routes>` の代わりにこれを使う。
 * Sentry 未初期化時は通常の `<Routes>` として振る舞う。
 */
export const SentryRoutes = Sentry.wrapReactRouterRouting(Routes)
